import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useIntl } from 'react-intl-next';
import { useDefaultSuppliers } from '../..';
import { usePeopleAndTeamsQuery } from '../../../common/clients/people-and-teams-supplier';
import { messages } from './messages';
import { getTeamData } from './teams-client';
import { CompassScope } from './types';
import { compassURLGenerators } from './url-generators';
import { peopleAndTeamsResultRenderer } from './result-renderer';
export var COMPASS_PRODUCT_ID = 'compass';
var NO_OWNER_TEAM = 'ari:cloud:teams::team/unidentified';
export var useCompassSuppliers = function useCompassSuppliers(_ref, sections) {
  var _resolveTeamUrl, _resolveUserUrl;
  var userTeamConfig = _ref.userTeamConfig,
    preQueryItemSupplier = _ref.preQueryItemSupplier,
    postQueryItemSupplier = _ref.postQueryItemSupplier;
  var intl = useIntl();
  var itemSuppliers = useDefaultSuppliers(COMPASS_PRODUCT_ID, sections, {
    preQueryItemSupplier: preQueryItemSupplier,
    postQueryItemSupplier: postQueryItemSupplier
  });
  var peopleAndTeamSupplier = usePeopleAndTeamsQuery({
    people: {
      id: CompassScope.People,
      title: intl.formatMessage(messages.compass_people_section_heading)
    },
    teams: {
      id: CompassScope.Teams,
      title: intl.formatMessage(messages.compass_teams_section_heading)
    }
  }, 3);
  var requestTeamMeta = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(teamId) {
      var team;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(!teamId || teamId === NO_OWNER_TEAM)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", '');
          case 2:
            _context.prev = 2;
            _context.next = 5;
            return getTeamData((userTeamConfig === null || userTeamConfig === void 0 ? void 0 : userTeamConfig.baseUrl) || '', teamId);
          case 5:
            team = _context.sent;
            return _context.abrupt("return", team.displayName);
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](2);
            return _context.abrupt("return", '');
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 9]]);
    }));
    return function requestTeamMeta(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var userTeamConfigOverride = {
    context: userTeamConfig.context,
    baseUrl: userTeamConfig.baseUrl,
    resolveTeamUrl: (_resolveTeamUrl = userTeamConfig.resolveTeamUrl) !== null && _resolveTeamUrl !== void 0 ? _resolveTeamUrl : compassURLGenerators().teamUrlGenerator,
    resolveUserUrl: (_resolveUserUrl = userTeamConfig.resolveUserUrl) !== null && _resolveUserUrl !== void 0 ? _resolveUserUrl : compassURLGenerators().userUrlGenerator
  };
  var hydrateOwnerMeta = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(items) {
      var promises, compSection;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            promises = [];
            compSection = items.sections.find(function (s) {
              return s.id === CompassScope.Component;
            });
            if (compSection) {
              compSection.searchResults.map( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(res) {
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        promises.push(requestTeamMeta(res.meta).then(function (teamName) {
                          return res.meta = teamName;
                        }));
                      case 1:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x3) {
                  return _ref4.apply(this, arguments);
                };
              }());
            }
            return _context3.abrupt("return", Promise.all(promises).then(function () {
              return items;
            }));
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function hydrateOwnerMeta(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  var preQueryItemSupplierWithTeamName = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(args) {
      var existingSections, teamSection;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.t0 = hydrateOwnerMeta;
            _context4.next = 3;
            return itemSuppliers.preQueryItemSupplier(args);
          case 3:
            _context4.t1 = _context4.sent;
            _context4.next = 6;
            return (0, _context4.t0)(_context4.t1);
          case 6:
            existingSections = _context4.sent;
            _context4.next = 9;
            return peopleAndTeamSupplier('', userTeamConfigOverride);
          case 9:
            teamSection = _context4.sent.sections.find(function (section) {
              return section.id === CompassScope.Teams;
            });
            return _context4.abrupt("return", window.location.pathname.startsWith('/compass') ? existingSections : {
              size: existingSections.size,
              sections: [].concat(_toConsumableArray(existingSections.sections), _toConsumableArray(teamSection ? [_objectSpread(_objectSpread({}, teamSection), {}, {
                resultRenderer: peopleAndTeamsResultRenderer
              })] : []))
            });
          case 11:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function preQueryItemSupplierWithTeamName(_x4) {
      return _ref5.apply(this, arguments);
    };
  }();
  var postQueryItemSupplierWithPeopleAndTeams = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(args) {
      var _people$sections$map;
      var existingSections, people;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.t0 = hydrateOwnerMeta;
            _context5.next = 3;
            return itemSuppliers.postQueryItemSupplier(args);
          case 3:
            _context5.t1 = _context5.sent;
            _context5.next = 6;
            return (0, _context5.t0)(_context5.t1);
          case 6:
            existingSections = _context5.sent;
            if (!userTeamConfigOverride) {
              _context5.next = 13;
              break;
            }
            _context5.next = 10;
            return peopleAndTeamSupplier(args.query, _objectSpread(_objectSpread({}, userTeamConfigOverride), {}, {
              context: _objectSpread(_objectSpread({}, userTeamConfigOverride.context), {}, {
                siteId: userTeamConfigOverride.context.siteId
              })
            }));
          case 10:
            _context5.t2 = _context5.sent;
            _context5.next = 14;
            break;
          case 13:
            _context5.t2 = null;
          case 14:
            people = _context5.t2;
            return _context5.abrupt("return", {
              size: existingSections.size,
              sections: [].concat(_toConsumableArray(existingSections.sections), _toConsumableArray((_people$sections$map = people === null || people === void 0 ? void 0 : people.sections.map(function (section) {
                return _objectSpread(_objectSpread({}, section), {}, {
                  resultRenderer: peopleAndTeamsResultRenderer
                });
              })) !== null && _people$sections$map !== void 0 ? _people$sections$map : []))
            });
          case 16:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function postQueryItemSupplierWithPeopleAndTeams(_x5) {
      return _ref6.apply(this, arguments);
    };
  }();
  var preQuerySectionTitleGenerator = function preQuerySectionTitleGenerator(section) {
    switch (section.id) {
      case CompassScope.Component:
        return window.location.pathname.startsWith('/compass') ? intl.formatMessage(messages.compass_recently_viewed_components) : intl.formatMessage(messages.compass_components_section_heading);
      case CompassScope.Teams:
        return window.location.pathname.startsWith('/compass') ? intl.formatMessage(messages.compass_recently_viewed_teams) : intl.formatMessage(messages.compass_teams_section_heading);
      default:
        return '';
    }
  };
  return {
    preQueryItemSupplier: preQueryItemSupplierWithTeamName,
    postQueryItemSupplier: postQueryItemSupplierWithPeopleAndTeams,
    preQuerySectionTitleGenerator: preQuerySectionTitleGenerator
  };
};